// Display-side mirror of `RateCalculator.netTakerBid` from
// arbitrage-core/services/position-unwinder/src/engine/rate-calculator.service.ts.
// The engine remains the authoritative source for order placement; this
// helper only exists so the Sum-of-Sides tab's Live Sums and Simulation
// cells match what the engine actually compares against `thresholdSum`.

const KALSHI_TAKER_FEE_RATE = 0.07;

// Mirrors `polymarketTakerFeeRate` in
// services/position-unwinder/src/constants.ts. Keep in sync with backend.
export const polymarketTakerFeeRate = (category?: string): number => {
  if (category === 'sports') return 0.03;
  if (category === 'crypto') return 0.072;
  return 0.072; // conservative default
};

export const netKalshiTakerBid = (raw: number): number => {
  const fee = KALSHI_TAKER_FEE_RATE * raw * (1 - raw);
  return raw - fee;
};

export const netPolymarketTakerBid = (
  raw: number,
  category?: string
): number => {
  const rate = polymarketTakerFeeRate(category);
  if (rate <= 0) return raw;
  const fee = rate * raw * (1 - raw);
  return raw - fee;
};
